import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domConstructTyped from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import QAForm from './QADialog/QAForm';
import template from './OccurrenceCommentsList.html?raw';
// NOTE (JS2TS): dropped dead dep dojo/date/locale (not used). xstyle/css!./OccurrenceList.css was already commented out.
// Tabulator = runtime global; DOM-heavy → dom-construct aliased.
declare const Tabulator: any;
const domConstruct: any = domConstructTyped;

class OccurrenceCommentsList extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    occurrenceID: any = null;
    occurrence: any = null;
    _comments: any = [];
    _requestedCommentId: any = null;
    _state = "new";

    dialog: any = null;
    qaForm: any = null;

    commentsTable: any = null;

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.RequestManager.silentExceptions = true;
    }

    startup(entitylist?: any): void {
        super.startup.apply(this, arguments as any);

        this.setNewButtonVisibility();

        if (typeof (entitylist) != "undefined") {
            domClass.remove(this.sectionComments, "w3-hide");
            this._onLoadCommentsResponse(entitylist);
        } else {
            this.loadComments();
        }
    }

    setNewButtonVisibility(bOverrideBoolValue?: any): any {
        var actualValue = false;

        if (bOverrideBoolValue === true || bOverrideBoolValue === false) {
            actualValue = bOverrideBoolValue;
        } else if (this.occurrence != null) {
            actualValue = this.occurrence.canCreateComment == true;
        } else {

        }

        if (actualValue === true) {
            domClass.remove(this.btnNewComment, "w3-hide");
        } else {
            domClass.add(this.btnNewComment, "w3-hide");
        }

        return actualValue;
    }

    loadComments(): void {

        domClass.add(this.sectionComments, "w3-hide");

        this._comments = [];

        var url = window.appRoot + "Occurrence/GetCommentList";

        if (this.occurrenceID == null || typeof (this.occurrenceID) == "undefined") {
            return;
        }

        domClass.remove(this.sectionComments, "w3-hide");

        this.StandbyStart();
        this._state = "loading";

        this.RequestManager.post(
            url,
            {
                occurrenceID: this.occurrenceID
            },
            lang.hitch(this, "_onLoadCommentsResponse"),
            lang.hitch(this, "_onLoadCommentsError"),
            false // sync
        );
    }

    _onLoadCommentsResponse(commentList: any): void {
        this.StandbyStop();
        this._state = "ready";
        this._comments = commentList;
        //console.log("_onLoadCommentsResponse", commentList);

        if (commentList.length > 0) {
            domClass.remove(this.CommentsContainer, "w3-hide");
        } else {
            if (this.setNewButtonVisibility() === true) {
                domClass.add(this.CommentsContainer, "w3-hide");
            } else {
                domClass.remove(this.CommentsContainer, "w3-hide");
                domConstruct.empty(this.CommentsContainer);
                domConstruct.create("div", {
                    style: {
                        "fontStyle": "italic"
                    },
                    className: "w3-text-gray",
                    "innerHTML": this.translations["General_noEntries"]//"keine Einträge"
                }, this.CommentsContainer)
            }

            return;
        }

        // employeeTasksContainer
        this.commentsTable = new Tabulator(this.CommentsContainer, {
            data: commentList,
            layout: "fitColumns",
            //height: "311px",
            columns: [
                {
                    title: this.translations["OccurrenceCommentDialog__TableCol_Question"]/*"Frage"*/, field: "question", /*width: 100,*/ editor: false
                },
                {
                    title: this.translations["OccurrenceCommentDialog__TableCol_QuestionAuthor"]/*"von"*/, field: "ref_asker.dispname", /*width: 100,*/ editor: false
                },
                {
                    title: this.translations["OccurrenceCommentDialog__TableCol_Answer"]/*"Antwort"*/, field: "answer", /*width: 150,*/ editor: false, formatter: lang.hitch(this, "tableFormatterStatus")
                },
                {
                    title: this.translations["OccurrenceCommentDialog__TableCol_AnswerAuthor"]/*"von"*/, field: "ref_responder.dispname", /*width: 150,*/ editor: false, formatter: lang.hitch(this, "tableFormatterStatus")
                },
                {
                    title: this.translations["OccurrenceCommentDialog__TableCol_Actions"]/*"Aktionen"*/, field: "ID", width: 50, formatter: lang.hitch(this, "tableBtnActions"), headerSort: false
                },

            ],
            //rowFormatter: lang.hitch(this, "_appendNestedTable"),
        });

        if (this._requestedCommentId != null) {
            this.showComment(this.getCommentFromList(this._requestedCommentId), this.occurrenceID);
        }
    }

    //custom formatter definition
    tableBtnActions(cell: any, formatterParams: any, onRendered: any): any { //plain text value

        var data = cell.getRow().getData();

        var container = domConstruct.create("div");

        if (data._isResponder == true || data._isAsker == true) {
            var button = domConstruct.create("div");
            domClass.add(button, "w3-padding-small w3-center mds-bg-gray mds-hover-dark  w3-cell");
            domAttr.set(button, "innerHTML", "<i class='fa fa-pencil'>&nbsp;</i>");
            domAttr.set(button, "title", this.translations["OccurrenceCommentDialog__TableBtnEdit"]);
            domConstruct.place(button, container);
            on(button, "click", lang.hitch(this, "_onClick__EditComment", data));
        } else {
            var button = domConstruct.create("div");
            domClass.add(button, "w3-padding-small w3-center mds-bg-gray mds-hover-dark  w3-cell");
            domAttr.set(button, "innerHTML", "<i class='fa fa-external-link-square'>&nbsp;</i>");
            domAttr.set(button, "title", this.translations["OccurrenceCommentDialog__TableBtnShow"]);//"anzeigen");
            domConstruct.place(button, container);
            on(button, "click", lang.hitch(this, "_onClick__EditComment", data));
        }

        return container;
    }

    getCommentFromList(ID: any): any {
        //console.log("getCommentFromList", ID, this._comments);
        for (var i = 0; i < this._comments.length; i++) {
            var comment = this._comments[i];

            if (comment.ID == ID) {
                return comment;
                break;
            }
        }
    }

    requestComment(ID: any): void {
        this._requestedCommentId = ID;
        //console.log("requestComment", this._state);
        if (this._state == "ready") {

            this.showComment(this.getCommentFromList(ID), this.occurrenceID);
        }
    }

    showComment(entity: any, occurrenceID: any): void {

        if ((entity == null || typeof (entity) == "undefined") && this._requestedCommentId != null) {
            console.warn(this.translations["OccurrenceCommentList__EntityNotFound"]);//"Gesucherter Kommentar existiert nicht");
            alert(this.translations["OccurrenceCommentList__EntityNotFound"]); // hihi, "gesuchert"
            return;
        }

        this._requestedCommentId = null;

        var dialog: any = new GenericDialog();
        this.dialog = dialog;

        dialog.hideSubtitleNode();

        this.genericDialog = dialog;
        domStyle.set(dialog.textNode, "height", "unset");

        var qa = new QAForm();
        qa.occurrenceID = occurrenceID;
        qa.startup(entity);

        dialog.addNodeToContent(qa.domNode);

        // verhinden dass mit "Enter" der Dialog beendet wird
        on(qa.domNode, "keyup", function (evt: any) {
            evt.stopPropagation();
        });

        dialog.set("header", this.translations["OccurrenceCommentDialog__Heading"]); //"Frage & Antwort");
        //dialog.set("content", "Hier Freitexteingabe");
        dialog.set("callback", lang.hitch(this, "qaDialogCallback", qa));

        if (entity != null && entity._isAsker != true && entity._isResponder != true) {
            //dialog.set("ok", false);
            //dialog.set("cancel", false);
            dialog.set("close", true);
        } else {
            dialog.set("ok", true);
            dialog.set("cancel", true);
        }

        dialog.show();
    }

    _onClick_NewComment(evt: any): void {
        evt.stopPropagation();

        this.showComment(null, this.occurrenceID);
    }

    _onClick__EditComment(entity: any, occurrenceID?: any): void {
        this.showComment(entity, occurrenceID);
    }

    _onLoadCommentsError(error: any): void {
        this.StandbyStop();

        console.error(error.Message);
    }

    qaDialogCallback(qa: any, result: any): void {
        qa.serializeData();
        var data = qa.get("data");

        console.log("qaDialogCallback", data, result);

        this.dialog = null;
        this.qaForm = null;

        if (result != 1) {
            return;
        }

        this.saveComment(data);
    }

    saveComment(data: any): void {

        this.StandbyStart();

        var url = window.appRoot + "Occurrence/SaveComment";

        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, "_onSaveCommentResponse"),
            lang.hitch(this, "_onSaveCommentError"),
            false // sync
        );
    }

    _onSaveCommentResponse(response: any): void {
        this.StandbyStop();
        this.loadComments();

        this.emit("CommentSaved");
    }

    _onSaveCommentError(error: any): void {
        this.StandbyStop();

        alert(this.translations["OccurrenceCommentDialog__ErrorSave"] + error.Message);
    }

    tableFormatterStatus(cell: any, formatterParams: any, onRendered: any): any {

        var data = cell.getData();
        var value = cell.getValue();

        // pit-Farbe wird in BGR zurückgegeben. ganz toll.
        // aabbcc:ddeeff der hintere Teil interessiert uns

        return value;
    }
}
OccurrenceCommentsList.prototype.declaredClass = 'WidgetCollection.JDM.Occurrence.OccurrenceCommentsList';

export default mdsWidget(OccurrenceCommentsList);
